import React, { useCallback, useEffect, useState } from "react";

import { goTo, useAppType, useLocation, useNavContext, useNavigate, useTranslation, useUserContext } from "utils";

import { Icon, Menu } from "components";

import { CTADrawerMobile } from "pages/app/_app/components/CTADrawerMobile";

export const AppNavBottom = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const appType = useAppType();
  const { t } = useTranslation("nav");

  const { showNavbar }: { showNavbar: boolean } = useNavContext();

  const { user } = useUserContext();

  const [key, setKey] = useState<string | null>(null);
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const [showNavDrawer, setShowNavDrawer] = useState(false);

  const checkKey = useCallback(() => {
    if (location.pathname.split("/")[3] && location.pathname.split("/")[3] === "articles") {
      return setKey("articles");
    }
    if (location.pathname.split("/")[3] && location.pathname.split("/")[3] === "knowledge") {
      return setKey("knowledge");
    }
    return setKey(location.pathname.split("/")[2]);
  }, [location.pathname]);

  const checkKeyboard = useCallback(() => {
    if (appType.app && window.cordova) {
      window.addEventListener("keyboardWillShow", () => {
        setKeyboardOpen(true);
      });
      window.addEventListener("keyboardWillHide", () => {
        setKeyboardOpen(false);
      });
    }
  }, [appType]);

  useEffect(() => {
    setShowNavDrawer(false);
    checkKey();
  }, [location.pathname]); // eslint-disable-line

  useEffect(() => {
    checkKeyboard();
    checkKey();
  }, []); // eslint-disable-line

  const getDynamicNavLink = () => {
    if (user?.farm && !user.farm.farmOnboarded) {
      return {
        link: "/dashboard?onboarding=true",
        label: t("ctaDrawer.createFarm"),
      };
    }
    return null;
  };

  const menuItems = [
    {
      label: t("mobileNav.app.home"),
      icon: <Icon iconName="klim/klim" size="m" />,
      onClick: (e: React.MouseEvent<HTMLElement>) => goTo(e, navigate, "/dashboard"),
      key: "dashboard",
    },
    {
      label: t("mobileNav.app.knowledge"),
      icon: <Icon iconName="tabler/news" size="m" />,
      onClick: (e: React.MouseEvent<HTMLElement>) => goTo(e, navigate, "/search/knowledge"),
      key: "knowledge",
    },
    {
      key: "CTA",
    },
    {
      label: t("mobileNav.app.farm"),
      icon: <Icon iconName="klim/farm-new" size="m" />,
      onClick: (e: React.MouseEvent<HTMLElement>) => goTo(e, navigate, "/farm"),
      key: "farm",
    },
  ];

  return (
    <section className={keyboardOpen || !showNavbar ? "app-navbar-bottom hide" : "app-navbar-bottom"}>
      {/* @ts-expect-error convert to TS */}
      <Menu mode="inline" selectedKeys={[key]} items={menuItems} />

      <div className="nav-cta" onClick={() => setShowNavDrawer(true)}>
        <Icon iconName="klim/plus" />
      </div>
      <CTADrawerMobile
        dynamicNavLink={getDynamicNavLink()}
        translations={{
          addNote: t("ctaDrawer.addNote"),
          startThread: t("ctaDrawer.startThread"),
        }}
        visible={showNavDrawer}
        onClose={() => setShowNavDrawer(false)}
      />
    </section>
  );
};

export default AppNavBottom;
